import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './resources';

const browserLang = typeof navigator !== 'undefined' ? navigator.language.slice(0, 2) : 'en';
const fallbackLng = browserLang === 'ru' ? 'ru' : 'en';

void i18n.use(initReactI18next).init({
    resources,
    lng: fallbackLng,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    returnNull: false,
});

export default i18n;
